import React, { useRef } from "react";

import styled from "styled-components";

import useToast from "components/atoms/toast/useToast";

import ReferenceBibInfoForm from "components/organisms/reference/ReferenceBibInfoForm";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import useSpaceNavigate from "hooks/useSpaceNavigate";

import { getDefaultBibtex } from "utils/bibtex";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddFormModal(props) {
    const { setToast } = useToast();

    const formRef = useRef();
    const { navigate } = useSpaceNavigate();
    const handleAddButton = () => {
        formRef.current.bibJsonMutate(formRef.current.getCurrentBibJson(), {
            onSuccess: (data) => {
                setToast("저장되었습니다.", "info");
                navigate("/reference/" + data.uuid);
            },
        });
    };

    return (
        <Container>
            <ReferenceBibInfoForm
                ref={formRef}
                bibliography={{
                    id: undefined,
                    bib_json: getDefaultBibtex().bib_json,
                }}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
            />
        </Container>
    );
}

export default ReferenceAddFormModal;
